<template>
  <v-card outlined>
    <v-app-bar color="blue-grey lighten-5" dense flat>
      <v-icon class="mr-2">{{ icon }}</v-icon>
      <h3>{{ title }}</h3>
      <v-spacer></v-spacer>
      <slot name="dialogButtons"></slot>
    </v-app-bar>
    <v-divider></v-divider>
    <v-container>
      <slot name="body"></slot>
    </v-container>
    <v-divider></v-divider>
    <v-card-actions class="align-right">
      <slot name="actions"></slot>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "HubbleDialog",
  props: ["title", "icon", "dialogButtons", "body", "actions"],
  data: () => ({
    dialog: false
  })
}
</script>
